import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useState,
} from "react";
import { StaffType } from "../types/StaffType";

export const StaffContext = createContext(
  {} as {
    staffList: StaffType[];
    setStaffList: Dispatch<SetStateAction<StaffType[]>>;
  }
);

export const StaffProvider = (props: any) => {
  const { children } = props;
  const [staffList, setStaffList] = useState<StaffType[]>(
    JSON.parse(localStorage.getItem("workingStaffList") as string) || []
  );

  return (
    <StaffContext.Provider value={{ staffList, setStaffList }}>
      {children}
    </StaffContext.Provider>
  );
};
